﻿export class WorkItemSecurityViolation {
}